/**
 * values for setting the 'filter scope' in 'filter' field
 */
import { locale } from './../../ModuleEditor/util/locale-wrapper';

const FILTER_SCOPE = {
  FIRST:  'first',
  SECOND: 'second',
  THIRD:  'third',
};

const FILTER_SCOPE_ALL = _.values(FILTER_SCOPE, 'value');

const FILTER_SCOPE_LIST = [
  { text: locale('First'), value: FILTER_SCOPE.FIRST, description: '' },
  { text: locale('Second'), value: FILTER_SCOPE.SECOND, description: '' },
  { text: locale('Third'), value: FILTER_SCOPE.THIRD, description: '' },
];

//object that shows that all marketing scopes are available
const AVAILABLE_DEFAULT_FILTER_SCOPES = {
  [FILTER_SCOPE.FIRST]:  '',
  [FILTER_SCOPE.SECOND]: '',
  [FILTER_SCOPE.THIRD]:  '',
};

export { FILTER_SCOPE, FILTER_SCOPE_LIST, FILTER_SCOPE_ALL, AVAILABLE_DEFAULT_FILTER_SCOPES };

export default FILTER_SCOPE;
